import { Preferences } from '@capacitor/preferences'
import { create } from 'zustand'

interface PreferencesStore {
	setItem: (key: string, value: string) => Promise<void>
	getItem: (key: string) => Promise<string | null>
	removeItem: (key: string) => Promise<void>
	clear: () => Promise<void>
	keys: () => Promise<string[]>
	appPreferencesLoaded: boolean,
	setAppPreferencesLoaded: (appPreferencesLoaded: boolean) => void,
}

const usePreferences = create<PreferencesStore>((set) => ({
	setItem: async (key: string, value: string) => {
		await Preferences.set({ key, value })
	},
	getItem: async (key: string) => {
		const { value } = await Preferences.get({ key })
		return value
	},
	removeItem: async (key: string) => {
		await Preferences.remove({ key })
	},
	clear: async () => {
		await Preferences.clear()
	},
	keys: async () => {
		const { keys } = await Preferences.keys()
		return keys
	},
	appPreferencesLoaded: false,
	setAppPreferencesLoaded: (appPreferencesLoaded: boolean) => set({ appPreferencesLoaded }),
}))

export default usePreferences